import { render, staticRenderFns } from "./itemCheckList.vue?vue&type=template&id=4b13b4b6&scoped=true&"
import script from "./itemCheckList.vue?vue&type=script&lang=js&"
export * from "./itemCheckList.vue?vue&type=script&lang=js&"
import style0 from "./itemCheckList.vue?vue&type=style&index=0&id=4b13b4b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b13b4b6",
  null
  
)

export default component.exports